import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLinkedin, FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import { isNotEmpty, YuklenenLogoUrl } from '../Utils';

export default function Footer({ logoSrc, adress, phone, mail, socialLinks, companyColor }) {
    const { t } = useTranslation("translation", { keyPrefix: "footer" });
    return (
        <footer className="custom_footer" style={{ ["--custom_footer-accent"]: companyColor }}>
            <div className="custom_footer-main">

                <div className="custom_footer-top">
                    {
                        isNotEmpty(logoSrc) && (
                            <img src={YuklenenLogoUrl + logoSrc} alt="Logo" className="custom_footer-logo" />
                        )
                    }
                    <div className="custom_footer-social">
                        <a href={socialLinks.Linkedin}><FaLinkedin /></a>
                        <a href={socialLinks.Facebook}><FaFacebook /></a>
                        <a href={socialLinks.Twitter}><FaTwitter /></a>
                        <a href={socialLinks.Instagram}><FaInstagram /></a>
                        <a href={socialLinks.Youtube}><FaYoutube /></a>
                    </div>
                </div>

                <hr className="custom_footer-divider" />

                <div className="custom_footer-contact-desktop">
                    <h4>{t("contact")}</h4>
                    <p>{mail}</p>
                    <p>{phone}</p>
                    <p>{adress}</p>
                </div>
                <div className="custom_footer-social-mobile">
                    <a href={socialLinks.Linkedin}><FaLinkedin /></a>
                    <a href={socialLinks.Facebook}><FaFacebook /></a>
                    <a href={socialLinks.Twitter}><FaTwitter /></a>
                    <a href={socialLinks.Instagram}><FaInstagram /></a>
                    <a href={socialLinks.Youtube}><FaYoutube /></a>
                </div>
            </div>

            <div className="custom_footer-bottom">
                <p>{t("rights")}</p>
            </div>
        </footer>
    );
}
